/**
 * RouteMap wrapper for delivery-admin
 * Re-exports the shared RouteMap from @flote/ui with the Mapbox token injected
 */
import { RouteMap as SharedRouteMap, type RouteMapProps as SharedRouteMapProps } from '@flote/ui';

// Re-export types and constants from shared package
export { ROUTE_COLORS, type TaskRoute, type BatchRoutesResponse, type GeoLocation, type RoutePoint, type RouteBounds, type RouteStatus } from '@flote/ui';

const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN ?? '';

export interface RouteMapProps extends Omit<SharedRouteMapProps, 'mapboxToken'> {
  // Token is automatically injected
}

export function RouteMap(props: RouteMapProps) {
  return <SharedRouteMap {...props} mapboxToken={MAPBOX_TOKEN} />;
}
